export const initialValues = {
  title: '',
  defaultIndex: '',
  style: 'default',
  lineStyle: 'linear',
  provider: 'typesense',
  groups: [],
};

export const groupDefaults = {
  label: '',
  labelFields: '',
  description: '',
  type: 'line',
  groupByFields: '',
  groupLabelFormat: '',
  filterBy: '',
  axes: {
    x: {
      label: '',
      field: '',
    },
    y: {
      label: '',
      field: '',
    }
  },
  tooltip: {
    title: '',
    text: '',
  },
  filters: [],
  colorsMap: [],
}

export const filterSourceDefaults = {
  label: '',
  attribute: '',
  kind: 'checkboxes',
  defaultValues: [],  // Array of default facet values to pre-select
};

export const lineColor = {
  id: '',
  color: '',
  lineStyle: 'solid',
  markerShape: 'circle',
  markerFill: 'filled',
};


export const colorPalette = {
  "brandGreen": "#76b900",

  // Sub Color Palette (ordered by number, highest to lowest)
  "green700": "#265600",
  "green500": "#337a00",
  "green300Brand": "#76b900",
  "green100": "#b2e639",
  "blue800": "#002781",
  "blue700": "#0046a4",
  "blue500": "#0074df",
  "blue200": "#7cd7fe",
  "fuschia800": "#5d1337",
  "fuschia700": "#8c1c55",
  "fuschia500": "#d2308e",
  "fuschia300": "#fc79ca",
  "fuschia100": "#ffd3f2",
  "purple800": "#4d1368",
  "purple700": "#741d9d",
  "purple400": "#c359ef",
  "purple100": "#f9d4ff",
  "red700": "#961515",
  "red500": "#e52020",
  "red300": "#ff8181",
  "red100": "#ffd7d7",
  "teal700": "#04554b",
  "teal500": "#0d8473",
  "teal300": "#1dbba4",
  "teal100": "#9aefe5",
  "yellow400": "#df6500",
  "yellow300": "#ef9100",
  "yellow200": "#f9c500",
  "yellow100": "#fcde7b",
}
